import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';
import { Header, Icon, Loader, Select } from 'semantic-ui-react';
import { PDFDownloadLink } from '@react-pdf/renderer';
import FilmAnalysis from './ReportComponent';
import { FilmData } from '../../app/stores/FilmAnaysisAndRepairReport/types';
import { useStore } from '../../app/stores/store';
import {} from 'semantic-ui-react';
import UnauthorizedMessage from '../UnauthorizedMessage';

function FilmAnalysis_RepairReport() {
  const {
    FilmAnaysisAndRepairReportStore,
    RolesAndPermissionsIDStore,
    commonStore,
  } = useStore();
  const {
    getTitleName,
    getTitleNameCount,
    setLoading,
    finalAnalysisRepairReports,
    Loading,
  } = FilmAnaysisAndRepairReportStore;
  const [filmDetails, setFilmDetails] = useState('');
  const [groupDetails, setGroupDetails] = useState<FilmData[]>([]);
  const [optionsList, setOptionsList] = useState([]);
  const [totalPageCount, seTotalPageCount] = useState<number>(0);

  useEffect(() => {
    getTitleName().then((Reponse) => {
      const dropdownValues = Reponse.map((name: string) => ({
        key: name,
        text: name,
        value: name,
      }));
      const nonEmptyValues = dropdownValues.filter(
        (item: any) => item.text.trim() !== '',
      );
      nonEmptyValues.sort((a: any, b: any) => a.text.localeCompare(b.text));
      setOptionsList(nonEmptyValues);
    });
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (!filmDetails) return;
    getTitleNameCount(filmDetails).then((Response) => {
      seTotalPageCount(Response);
    });
    finalAnalysisRepairReports(filmDetails).then((Response) => {
      setGroupDetails(Response);
    });
    // eslint-disable-next-line
  }, [filmDetails]);

  return (
    <>
      {!RolesAndPermissionsIDStore.loadingInitial &&
        !commonStore.filterModeOne?.includes('FARR01') && (
          <UnauthorizedMessage />
        )}
      {commonStore.filterModeOne?.includes('FARR01') && (
        <div>
          <div className="title_wise_cutlistreport">
            <Header>FILM ANALYSIS AND REPAIR REPORT</Header>
            <br />
            <div className="cutlist_report_flex">
              <Select
                style={{ marginRight: '10px' }}
                placeholder="Select Title"
                filter
                Selection
                search
                clearable
                options={optionsList}
                // options={selectedTitleCodeOptions}
                onChange={(e, data) => {
                  setFilmDetails(data.value as string);
                  setLoading(true);
                }}
              />

              {!filmDetails ? (
                <></>
              ) : Loading ? (
                <Loader
                  active
                  inline
                  style={{ marginTop: '8px' }}
                  size="small"
                />
              ) : (
                <PDFDownloadLink
                  document={
                    <FilmAnalysis
                      totalPageCount={totalPageCount}
                      pageNumber={2}
                      GroupData={groupDetails}
                    />
                  }
                  // document={<></>}
                  fileName="FilmAnaysisAndRepairReport.pdf"
                  className="genRep"
                >
                  {({ loading }) =>
                    loading ? (
                      <div style={{ color: 'black' }}>
                        <Loader
                          active
                          inline
                          style={{ marginTop: '8px' }}
                          size="small"
                        />
                      </div>
                    ) : (
                      <Icon
                        corner="bottom right"
                        size="large"
                        circular
                        inverted
                        color="teal"
                        name="download"
                        // onClick={handleLoadMetaDataCount}
                      />
                    )
                  }
                </PDFDownloadLink>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
}
export default observer(FilmAnalysis_RepairReport);
